var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 7.375V4.5625C10.375 3.66739 10.0194 2.80895 9.38649 2.17601C8.75355 1.54308 7.89511 1.1875 7 1.1875C6.10489 1.1875 5.24645 1.54308 4.61351 2.17601C3.98058 2.80895 3.625 3.66739 3.625 4.5625V7.375M3.0625 15.8125H10.9375C11.3851 15.8125 11.8143 15.6347 12.1307 15.3182C12.4472 15.0018 12.625 14.5726 12.625 14.125V9.0625C12.625 8.61495 12.4472 8.18573 12.1307 7.86926C11.8143 7.55279 11.3851 7.375 10.9375 7.375H3.0625C2.61495 7.375 2.18573 7.55279 1.86926 7.86926C1.55279 8.18573 1.375 8.61495 1.375 9.0625V14.125C1.375 14.5726 1.55279 15.0018 1.86926 15.3182C2.18573 15.6347 2.61495 15.8125 3.0625 15.8125Z",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordicon);
export default __webpack_public_path__ + "static/media/passwordicon.5a25f39192b345a3f536fd4cfa6ec397.svg";
export { ForwardRef as ReactComponent };